/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { ClientNewsSource } from '@DigitaleDoerfer/digitale-doerfer-api';
import { TextField } from '@mui/material';

interface Props {
	pageOfClientNewsSource: ClientNewsSource[];
	handleSearch: (searchString: string) => void;
}

const SearchView = (props: Props): JSX.Element => {
	const { pageOfClientNewsSource, handleSearch } = props;

	const makefullListofitemsfromContent = (clientNewsSource: ClientNewsSource[]): Array<string | undefined> => {
		const listOfNewsSourceSiteName = clientNewsSource.map(option => option.siteName);
		const listOfNewsSourceSiteUrl = clientNewsSource.map(option => option.siteUrl);
		const listOfNewsSourceSiteNameandURL = [];
		for (let i = 0; i < listOfNewsSourceSiteName.length; i++) {
			listOfNewsSourceSiteNameandURL[i] = listOfNewsSourceSiteName[i] + ' | ' + listOfNewsSourceSiteUrl[i];
		}
		return listOfNewsSourceSiteNameandURL;
	};

	const handleChange = (event: React.ChangeEvent<unknown>, value: string): void => {
		if (event.type === 'click') {
			//workaround for @typescript-eslint/no-unused-vars
		}
		const valueURL = value.split('|')[1].trimLeft();
		pageOfClientNewsSource.forEach(options => {
			if (options.siteUrl) {
				if (valueURL === options.siteUrl) {
					handleSearch(options.id as string);
				}
			}
		});
	};
	return (
		<Autocomplete
			freeSolo
			disableClearable
			options={makefullListofitemsfromContent(pageOfClientNewsSource)}
			onChange={handleChange}
			renderInput={(params): JSX.Element => (
				<TextField
					variant="standard"
					{...params}
					label="NewsSource suchen"
					placeholder="Seitename, URL"
					InputProps={{ ...params.InputProps, type: 'search' }}
					id="standard-search"
					type="search"
					InputLabelProps={{
						shrink: true
					}}
					fullWidth
					autoFocus
				/>
			)}
		/>
	);
};

export default SearchView;
